import { gql, useMutation } from "@apollo/client";

const DELETE_DESIGNER_APPLICATION_MUTATION = gql`
  mutation DeleteDesignerApplication($applicationId: ID!) {
    deleteDesignerApplication(applicationId: $applicationId)
  }
`;

export const useDeleteDesignerApplicationMutation = () => {
  const [deleteDesignerApplicationMutation, { loading, error, data }] = useMutation(
    DELETE_DESIGNER_APPLICATION_MUTATION
  );

  const deleteDesignerApplication = async (applicationId: string) => {
    try {
      const { data } = await deleteDesignerApplicationMutation({
        variables: { applicationId },
      });
      return data?.deleteDesignerApplication;
    } catch (error) {
      console.error("Error deleting designer application:", error);
      throw error;
    }
  };

  return { deleteDesignerApplication, loading, error, data };
};
